import {computed, observable} from "mobx";
import {MobXHelper, VarHelper} from "common-import/helpers";
import api from "./BiddingCategory.API";

const { makePersit } = MobXHelper;

class BiddingCategoryStore {
  @observable listApproved = [];

  @observable listNotApproved = [];

  @observable currentBidding = {};

  @computed get allListProject() {
    return [...this.listApproved, ...this.listNotApproved];
  }

  setProp = (prop, value) => { this[prop] = value  };

  getAll = async (page) => {
    let res = await api.adminList({
      // "orderBy":"createdAt",
      // "orderType":"DESC",
      "page": page || 1
    });
    let json = await res.json();
    if (!!json.error) return { status: false, error: json.error };
    this.listApproved = json.data;
    return { status: true };
  };
  
  getListApproved = async (page) => {
    let res = await api.adminList({
      // "orderBy": "updatedAt",
      // "orderType": "DESC",
      "approved": 1,
      "page": page || 1
    });
    let json = await res.json();
    if(!!json.error) return { status: false, error: json.error };
    this.listApproved = json.data;
    return { status: true };
  };

  getListNotApproved = async (page) => {
    let res = await api.adminList({
      // "orderBy": "updatedAt",
	    // "orderType": "DESC",
      "approved": 0,
      "page": page || 1
    });
    let json = await res.json();
    if(!!json.error) return { status: false, error: json.error };
    this.listNotApproved = json.data;
    return { status: true };
  };

  getListNotApprovedUpdate = async (page) => {
    let res = await api.adminList({
      // "orderBy": "updatedAt",
	    // "orderType": "DESC",
      "approved": 3,
      "page": page || 1
    });
    let json = await res.json();
    if(!!json.error) return { status: false, error: json.error };
    this.listNotApproved = json.data;
    return { status: true };
  };

  search = async (name, approved) => {
    let res = await api.adminList({
      "name": name,
      "orderBy": "updatedAt",
	    "orderType": "DESC",
	    "approved": approved
    });
    let json = await res.json();
    if (!!json.error) return { status: false, error: json.error };
    if (approved === 1) {
      this.listApproved = json.data;
    } else {
      this.listNotApproved = json.data;
    }
    return { status: true };
  };

  getBiddingDetail = async id => {
    const res = await api.detail(id);
    const json = await res.json();
    this.currentBidding = VarHelper.cloneDeep(json.data);
    return json.data;
  };

  update = async data => {
    const { id } = this.currentBidding;
    if (!id) return;
    const res = await api.update(id, data);
    if (res.validateError) {
      return { error: res.validateError };
    }
    return await res.json();
  };

  create = async data => {
    const res = await api.create(data);
    if (!!res.validateError) {
      return { error: res.validateError };
    }
    return await res.json();
  };

  approve = async ({ id, approved }) => {
    const res = await api.approve({ id, approved: approved ? 1 : 0 });
    if (!!res.validateError) {
      return { error: res.validateError };
    }
    return await res.json();
  };

  delete = async (data) => {
    const res = await api.delete(data);
    if (!!res.validateError) {
      return { error: res.validateError };
    }
    return await res.json();
  };

  getListWithProjectId = async ({projectId}) => {
    const res = await api.list({projectId});
    if (!!res.validateError) {
      return { error: res.validateError };
    }
    return await res.json();
  }
}

export default new BiddingCategoryStore();



// WEBPACK FOOTER //
// ./src/services/biddingCategory/BiddingCategory.Store.js